import React from 'react';
import { StyleSheet, View } from 'react-native';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';
import { MainButton } from '../buttons/MainButton.js';

const styles = StyleSheet.create({
  grayLayer: {
    display: 'block',
    position: 'fixed',
    zIndex: 999,
    backgroundColor: theme.BLACK_COLOR_TRANSPARENT,
    width: '100%',
    height: '100%',
  },
  container: {
    position: 'absolute',
    width: '100%',
    padding: theme.CONTAINER_MARGIN,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.GREEN_DARKER_COLOR,
    zIndex: 1000,
  },
  innerContainer: {
    width: '85%',
    padding: 20,
  },
  headline: {
    fontSize: theme.FONT_SIZE_HEADLINE,
    color: theme.WHITE_COLOR,
    fontWeight: theme.FONT_WEIGHT_BOLD,
    marginBottom: 5,
    textAlign: 'center',
  },
  text: {
    fontSize: theme.FONT_SIZE_REGULAR,
    color: theme.WHITE_COLOR,
    paddingBottom: 20,
    textAlign: 'center',
  },
  animatedContainer: {
    flex: 1,
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default class CookiePopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cookieName: 'CookiePopup',
      cookieSet: false,
      message:
        'We use cookies to ensure that we give you the best experience on our website. By selecting to close this alert, you are agreeing to allowing this site to use 3rd party cookies.',
      expiresIn: 365,
    };
  }

  componentDidMount() {
    this.checkCookie();
  }

  onAccept() {
    this.setCookie();
    this.setState({ cookieSet: true });
  }

  setCookieValue = () => {
    // eslint-disable-next-line no-bitwise
    const a = () => (((1 + Math.random()) * 65536) | 0).toString(16).substring(1);
    return `${a() + a()}-${a()}-${a()}${a()}${a()}`;
  };

  setCookie() {
    const { cookieName, expiresIn } = this.state;

    const d = new Date();
    const cvalue = this.setCookieValue();
    d.setTime(d.getTime() + expiresIn * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cookieName}=${cvalue}; ${expires}`;
  }

  getCookie() {
    const { cookieName } = this.state;

    const name = `${cookieName}=`;
    const re = new RegExp(`${name}([^;]+)`);
    const value = re.exec(document.cookie);
    return value != null ? unescape(value[1]) : null;
  }

  checkCookie() {
    const cookie = this.getCookie();
    if (cookie) {
      this.setState({ cookieSet: true });
    }
  }

  render() {
    const { message, cookieSet } = this.state;
    if (!cookieSet) {
      return (
        <View style={styles.grayLayer}>
          <View style={styles.container}>
            <View style={styles.innerContainer}>
              <CustomText style={styles.headline}>
                Accept Turtlet Cookies in this browser
              </CustomText>
              <CustomText style={styles.text}>{message}</CustomText>
              <MainButton
                title="Accept"
                btnBgColor={theme.WHITE_COLOR}
                textColor={theme.GREEN_DARKER_COLOR}
                btnTextSize={15}
                btnWidth={200}
                btnPadding="5%"
                btnPress={() => this.onAccept()}
                style={styles.loginButton}
                testID="acceptCookies"
              />
            </View>
          </View>
        </View>
      );
    }
    return null;
  }
}
